import { addDays } from 'date-fns';
import { useContext } from 'react';
import { AppContext } from '../AppContext';

export const useGenerateTasksForHarvest = () => {
  const { user } = useContext(AppContext);

  const generateTasksForHarvest = ({
    harvestId,
    seedName,
    startDate,                 // ISO string
    germinationDays = 0,       // days until germination ends
    blackoutDays = 0,          // days of blackout after germination
    growthDays = 0,            // days from sow to harvest
    wateringFrequency = 1,     // every N units
    wateringIntervalUnit = 'days', // 'days' or 'weeks'
    dryDay = false,            // if true, skip watering the day before harvest
  }) => {
    const tasks = [];
    const userId = user?.uid;
    if (!userId || !startDate) return [];

    const start           = new Date(startDate);
    const germinationEnd  = addDays(start, Number(germinationDays));
    const lightsDate      = addDays(germinationEnd, Number(blackoutDays));
    const harvestDate     = addDays(start, Number(growthDays));
    // compute the actual “dry” date (day before harvest)
    const dryDate         = dryDay ? addDays(harvestDate, -1) : null;

    const getLabel = () => seedName;

    // 1) Sow / Start
    tasks.push({
      type: 'sow',
      date: start.toISOString(),
      harvestId,
      label: getLabel(),
      harvestStartDate: start.toISOString(),
      done: false,
      userId,
    });

    // 2) Blackout (end of germination)
if (Number(blackoutDays) > 0) {
  tasks.push({
    type: 'blackout',
    date: germinationEnd.toISOString(),
    harvestId,
    label: getLabel(),
    harvestStartDate: start.toISOString(),
    done: false,
    userId,
  });
}

    // 3) Lights (end of blackout)
    tasks.push({
      type: 'lights',
      date: lightsDate.toISOString(),
      harvestId,
      label: getLabel(),
      harvestStartDate: start.toISOString(),
      done: false,
      userId,
    });

    // 4) Watering from startDate onward, skipping dry date
    const intervalDays =
      wateringIntervalUnit === 'weeks'
        ? wateringFrequency * 7
        : wateringFrequency;

    for (
      let current = start;
      current < harvestDate;
      current = addDays(current, intervalDays)
    ) {
      // if dryDay is true and this is the day before harvest, skip it
      if (dryDate && current.toDateString() === dryDate.toDateString()) {
        continue;
      }
      tasks.push({
        type: 'water',
        date: current.toISOString(),
        harvestId,
        label: getLabel(),
        harvestStartDate: start.toISOString(),
        done: false,
        userId,
      });
    }

    // 5) Harvest
    tasks.push({
      type: 'harvest',
      date: harvestDate.toISOString(),
      harvestId,
      label: getLabel(),
      harvestStartDate: start.toISOString(),
      done: false,
      userId,
    });

    return tasks;
  };

  return generateTasksForHarvest;
};
